import React from 'react'
import { Resource } from 'react-admin'
import RESOURCES from '../constants/resources'
import withAuthHOC from '../../components/withAuthHOC/withAuthHOC'

const resourcesWithAuth = () =>
  RESOURCES.map((route) => {
    const {
      name,
      list,
      create,
      edit,
      show,
      allowedAddons,
      allowedOrgAddons,
      allowedUserOrgRoles,
      payLocked,
    } = route

    return (
      <Resource
        key={name}
        name={name}
        list={withAuthHOC(allowedOrgAddons, allowedAddons, allowedUserOrgRoles, payLocked)(list)}
        create={withAuthHOC(
          allowedOrgAddons,
          allowedAddons,
          allowedUserOrgRoles,
          payLocked,
        )(create)}
        edit={withAuthHOC(allowedOrgAddons, allowedAddons, allowedUserOrgRoles, payLocked)(edit)}
        show={withAuthHOC(allowedOrgAddons, allowedAddons, allowedUserOrgRoles, payLocked)(show)}
      />
    )
  })

export default resourcesWithAuth
